import { loadable } from '@fiverr-private/perseus';

const TableOfContents = loadable(() => import(/* webpackChunkName: "TableOfContents" */ './TableOfContents'));

export const TABLE_OF_CONTENTS_CONFIG = {
    components: [
        {
            component: TableOfContents,
            options: {
                name: 'TableOfContents',
                inputs: [
                    {
                        name: 'isNumbered',
                        type: 'boolean',
                        required: false,
                        defaultValue: false,
                    },
                    {
                        name: 'h2',
                        type: 'boolean',
                        required: false,
                        defaultValue: false,
                    },
                    {
                        name: 'h3',
                        type: 'boolean',
                        required: false,
                        defaultValue: true,
                    },
                    {
                        name: 'defaultExpanded',
                        type: 'boolean',
                        required: false,
                        defaultValue: false,
                        helperText: 'When enabled, the Table of Contents starts expanded. Default: collapsed.',
                    },
                    {
                        name: 'usePageHeadings',
                        type: 'boolean',
                        required: false,
                        defaultValue: false,
                        helperText:
                            'When enabled, headings are detected from the page content. When disabled, headings are detected from each separate text block.',
                    },
                ],
            },
            noWrap: false,
            hasChildren: false,
        },
    ],
};
